/* Your order (sections/tm-order-lookup.liquid). The confirmation email's button carries the order itself,
 * base64url of a small json object in ?o=, because a Shopify page cannot read an order: Liquid has no
 * `order` object outside the notification templates and the Storefront API has no guest lookup. Possession
 * of the link is the access, the same way Shopify's own order status url works.
 *
 * The number in the payload is already the offset one the buyer reads in the email, so it is printed as it
 * arrives. Nothing here is trusted for anything but display. */
(function () {
  "use strict";

  var page = document.querySelector("[data-tm-lookup]");
  if (!page) return;

  var result = page.querySelector("[data-tm-lookup-result]");
  var empty = page.querySelector("[data-tm-lookup-empty]");
  var numberOut = page.querySelector("[data-tm-lookup-number-out]");
  var countOut = page.querySelector("[data-tm-lookup-count]");
  var lines = page.querySelector("[data-tm-lookup-lines]");
  var totalOut = page.querySelector("[data-tm-lookup-total]");

  function decode(value) {
    /* base64url from Liquid: the two swapped characters and any missing padding come back first. */
    var text = String(value).replace(/-/g, "+").replace(/_/g, "/");
    while (text.length % 4 !== 0) text += "=";
    var binary = window.atob(text);
    /* The titles carry accents, so the bytes have to be read as UTF-8 rather than latin-1. */
    var bytes = new Uint8Array(binary.length);
    for (var i = 0; i < binary.length; i += 1) bytes[i] = binary.charCodeAt(i);
    return JSON.parse(new TextDecoder("utf-8").decode(bytes));
  }

  var order = null;
  try {
    var raw = new URLSearchParams(window.location.search).get("o");
    if (raw) order = decode(raw);
  } catch (e) {
    order = null;
  }

  if (!order || !order.l || !order.l.length) return;

  function money(amount, currency) {
    var value = parseFloat(amount);
    if (isNaN(value)) return "";
    /* The email sends the shop's minor unit, the same as everywhere else in the clone. */
    value = value / 100;
    try {
      return new Intl.NumberFormat(undefined, { style: "currency", currency: currency || "USD" }).format(value);
    } catch (e) {
      return value.toFixed(2);
    }
  }

  function span(className, text) {
    var node = document.createElement("span");
    node.className = className;
    node.textContent = text;
    return node;
  }

  function row(line, currency) {
    var li = document.createElement("li");
    li.className = "tm-checkout__line";

    var text = document.createElement("div");
    text.className = "tm-checkout__line-text";
    text.appendChild(span("tm-checkout__line-name", line.t || ""));
    if (line.v && line.v !== "Default Title") text.appendChild(span("tm-checkout__line-variant", line.v));
    if (line.d) text.appendChild(span("tm-checkout__line-unit", line.d));
    if (line.w) text.appendChild(span("tm-checkout__line-unit", line.y ? line.w + ", " + line.y : line.w));

    var side = document.createElement("div");
    side.className = "tm-checkout__line-side";
    side.appendChild(span("tm-checkout__line-total", money(line.p, currency)));
    side.appendChild(span("tm-checkout__line-variant", "× " + line.q));

    li.appendChild(text);
    li.appendChild(side);
    return li;
  }

  if (numberOut) numberOut.textContent = "#" + order.n;

  /* Tickets first, extras after, and the ticket count said plainly: it is the thing the buyer came for. */
  var tickets = [];
  var extras = [];
  for (var i = 0; i < order.l.length; i += 1) (order.l[i].x ? extras : tickets).push(order.l[i]);

  var ticketCount = 0;
  for (var j = 0; j < tickets.length; j += 1) ticketCount += tickets[j].q || 0;

  if (countOut && ticketCount > 0) {
    var concert = tickets[0].t || "";
    countOut.textContent = ticketCount === 1 ? "1 ticket for " + concert : ticketCount + " tickets for " + concert;
    countOut.hidden = false;
  }

  if (lines) {
    lines.innerHTML = "";
    var ordered = tickets.concat(extras);
    for (var k = 0; k < ordered.length; k += 1) lines.appendChild(row(ordered[k], order.c));
  }

  if (totalOut) totalOut.textContent = money(order.t, order.c);

  /* Apple Wallet and Google Wallet live in the Event Pass app, reached through its proxy on this domain.
   * The order id travels in the link as `i`; without it there is nothing to point at, so the block stays
   * hidden rather than sending the visitor to an error. */
  var wallet = page.querySelector("[data-tm-lookup-wallet]");
  var walletLink = page.querySelector("[data-tm-lookup-wallet-link]");
  if (wallet && walletLink && order.i) {
    var path = wallet.getAttribute("data-wallet-path") || "/apps/eventpass/tickets";
    walletLink.href = path + "?order=" + encodeURIComponent(order.i);
    wallet.hidden = false;
  }

  if (result) result.hidden = false;
  if (empty) empty.hidden = true;
})();
